<div class="formly-field-wrap permissions-field-wrap">
  @if (isLoading) {
    <div class="loading-state">
      <ion-spinner name="crescent"></ion-spinner>
      <span>{{ 'COMMON.LOADING' | translate }}</span>
    </div>
  } @else if (loadError) {
    <div class="error-state">
      <span>{{ 'PERMISSIONS_FIELD.LOAD_FAILED' | translate }}</span>
      <ion-button fill="outline" size="small" (click)="retryLoad()">
        {{ 'ERRORS.RETRY' | translate }}
      </ion-button>
    </div>
  } @else if (tables.length === 0 || actions.length === 0) {
    <div class="empty-state">{{ 'PERMISSIONS_FIELD.EMPTY' | translate }}</div>
  } @else {
    <div class="matrix-shell">
      <table class="permissions-table">
        <thead>
          <tr>
            <th scope="col">{{ 'PERMISSIONS_FIELD.TABLE' | translate }}</th>
            @for (action of actions; track trackByAction($index, action)) {
              <th scope="col" class="permission-column">{{ getActionLabel(action) }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (table of tables; track trackByTable($index, table)) {
            <tr>
              <td class="table-column">
                <div class="table-name">{{ table.name }}</div>
                @if (table.comment) {
                  <div class="table-comment">{{ table.comment }}</div>
                }
              </td>
              @for (action of actions; track trackByAction($index, action)) {
                <td class="permission-column">
                  <ion-checkbox
                    [checked]="isPermissionGranted(table.name, action)"
                    [disabled]="isReadonly"
                    (ionChange)="onPermissionChange(table.name, action, $event.detail.checked)">
                  </ion-checkbox>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
  <ng-template #fieldComponent></ng-template>
</div>